import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import PollForm from "../../ui/PollForm/PollForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import { createPollAsync, clearPollForm } from "../../../redux/actions/editPoll";
import { openCancelModal, closeCancelModal } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editPoll,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: () => dispatch(push('/polls')),
  onCreatePoll: () => dispatch(createPollAsync()),
  clearForm: () => dispatch(clearPollForm()),
});

class CreatePoll extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    poll: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    onCreatePoll: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
  };

  formIsEmpty = () => {
    const { poll } = this.props;
    if ((poll.text.length === 0) //Название не меняли
      && (poll.answers.length === 2) //Ответы не добавляли
      && (poll.answers.every(answer => answer.text.length === 0)) //Все ответы пустые
      && (!poll.clients && !poll.consultants) //Оба чекбокса не меняли
    ) return true; 
    return false;
  }

  askOrGoBack = () => {
    const { poll, openCancelModal, onGoBack } = this.props;
    this.formIsEmpty(poll) ? onGoBack() : openCancelModal();
  }

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    closeCancelModal();
    clearForm();
    onGoBack();
  }

  render() {
    const { ready, loading, poll, cancelModal, closeCancelModal, onCreatePoll } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => this.askOrGoBack()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span> 
            </button>
          ) : false}
        </div>
        <div className="page-content forms">
          <div className="form-header">Создание опроса</div>
          {ready ? (
            <PollForm
              poll={poll}
              submitText="Создать опрос"
              onSubmit={() => onCreatePoll()}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(CreatePoll));
